/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Bottom_LeftInputs */



/**
* | output |
* | --- |
* | "Position Bottom Left" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Bottom_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_bottom_left = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Bottom_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Bottom_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner en bas a gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position unten links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione in basso a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция внизу слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición inferior izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置左下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左下の位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे बाईं ओर स्थित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição inferior esquerda")
	return /** @type {LocalizedString} */ ("Position Bottom Left")
});